(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('S3FileExplorerService', S3FileExplorerService);

    S3FileExplorerService.$inject = ['$http'];

    function S3FileExplorerService($http) {
        return {
            list: list,
            downloadUrl: downloadUrl,
            directoryCounts: directoryCounts
        };

        function list(storageSystem, prefix, continuationToken) {
            var config = { params: {} };
            config.params.storageSystem = storageSystem;
            if (prefix) config.params.prefix = prefix;
            if (continuationToken) config.params.continuationToken = continuationToken;
            return $http.get('/api/s3', config).then(function(resp) { return resp.data; });
        }

        function downloadUrl(storageSystem, key) {
            return '/api/s3/download?storageSystem=' + encodeURIComponent(storageSystem) + '&key=' + encodeURIComponent(key);
        }

        function directoryCounts(storageSystem, prefix) {
            return $http.get('/api/s3/directory-counts', {
                params: {
                    storageSystem: storageSystem,
                    prefix: prefix || ''
                }
            }).then(function(resp) { return resp.data; });
        }
    }
})();
